import type { AxiosRequestConfig } from 'axios';
import RequestService from './request';

export interface HelpSearchResult {
    corpus: string;
    slug?: string;
    url: string;
    title: string;
    description?: string | null;
    snippet?: string | null;
    category_path?: string | null;
    category_name?: string | null;
    platform?: string | null;
    platform_icon?: string | null;
}

export interface HelpSearchResponse {
    query_id: number | null;
    result_count: number;
    results: HelpSearchResult[];
}

export interface HelpSearchQuery {
    query: string;
    category_path?: string | null;
    limit?: number;
    session_id?: string | null;
}

export class HelpSearchService {
    search(data: HelpSearchQuery, config?: AxiosRequestConfig): Promise<HelpSearchResponse> {
        return RequestService.post('/help-search', data, config);
    }

    click(data: { query_id: number; clicked_url: string; clicked_position: number }): Promise<void> {
        return RequestService.post('/help-search/click', data);
    }
}

export default new HelpSearchService();
